import React, { useState } from "react";
import { validate } from "../../utilities/formValidators";
import classnames from "classnames";
import Input from "../Form/Input";

export interface IInputProps {
    id: string;
    label?: string;
    value?: any;
    inputType: string;
    iconClassName?: string;
    inputClassName?: string;
    showCurrencyIcon?: boolean;
    onChange: (value: any, name: string, isValid: boolean) => void;
    disabled?: boolean;
    className?: string;
    show: boolean;
    errorMessage?: string;
    emailErrorMessage?: string;
    errorClassName?: string;
}

export default (props: IInputProps) => {
    const { errorClassName, inputType, onChange, value, id, inputClassName, label, show, className, emailErrorMessage = "Please enter a proper email address", errorMessage = "Please enter a value" } = props;
    const [error, setError] = useState("");

    function handleInput(e: any) {
        const { name, value } = e.target;

        if (validate(value, inputType)) {
            setError("");
            onChange(name, value, true);
        } else {
            onChange(name, value, false);
        }
    }

    function handleBlur(e: any) {
        const value = e.target.value;
        if (!validate(value, inputType)) {
            if (inputType === "email") {
                setError(emailErrorMessage);
            } else {
                setError(errorMessage);
            }
        }
    }

    return (
        <Input
            className={classnames("form-group", className)}
            hasValue={(value.value + "").length > 0}
            error={error}
            errorClassName={errorClassName}
            label={label}
            id={id}>
            <input
                type="text"
                name={id}
                id={id}
                value={value.value}
                disabled={!show}
                onBlur={handleBlur}
                onChange={handleInput}
                className={classnames(inputClassName, "form-control", "px-3", { "has-label": label })}
                autoComplete="off"
            ></input>
        </Input>
    );
};